import React from 'react';
import SyncLoader from 'react-spinners/SyncLoader';

const LoadSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-holder">
        <SyncLoader color="#0072c3" loading size={24} />
      </div>
    </div>
  );
};

export default LoadSpinner;
